/**
 * 工具包统一放在此处
 */

const tools = {
    setFontSize(size) {
        let pageWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        let setSize = 16;
        if (size) {
            setSize = Math.floor((size * pageWidth) / 1920);
        }
        return setSize + "px";
    },
    getRandomKey: () =>
        `${Date.now()}${Math.random().toString(36).slice(2, 12)}`,
};

export default tools;



// WEBPACK FOOTER //
// ./src/utils/tools.js